// extracted by mini-css-extract-plugin
export default {"block":"SelectItemCompany_block__F+YDT","title":"SelectItemCompany_title__qnuda","inn":"SelectItemCompany_inn__tYN++"};